import React, { PropsWithChildren, useState } from 'react';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from 'shared/api';

// import { AxiosError } from 'axios';

const BaseQueryClientProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error: unknown) => {
            // NOTE: Only handler ApiError that is not handled by their own error handler
            if (error instanceof ApiError) {
              alert(error.message);
            }
          },
        }),

        defaultOptions: {
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
          },

          mutations: {
            retry: false,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default BaseQueryClientProvider;
